{
  "settings": {
    "language": {
      "label": "Language",
      "help": "More languages coming soon",
      "options": {
        "en": "English",
        "da": "Dansk"
      }
    }
  }
}
